export const flightPackages = ["PFF", "PFPF", "HF"]

export const ukTrainPackages = ["PFTT", "PFPTT", "PFPTT_7N6JS", "PFPTT_8N7JS", "PFTT_7N6JS", "PFTT_8N7JS", "HTT", "HTT_7N6JS", "HTT_8N7JS"]

export const frTrainPackages = ["PFPTTF", "PFPTTF_7N7JS", "PFPTTF_7N8JS", "PFTTF", "PFTTF_7N7JS", "PFTTF_7N8JS", "HTTF", "HTTF_7N7JS", "HTTF_7N8JS"]
export const nlTrainPackages = ["PFPTTNL", "PFPTTNL_7N7JS", "PFPTTNL_7N8JS", "PFTTNL", "PFTTNL_7N7JS", "PFTTNL_7N8JS", "HTTNL", "HTTNL_7N7JS", "HTTNL_7N8JS"]

export const tnePackages = ["TNE", "WTNE"]

export const trainPackagesFRorNL = [...frTrainPackages, ...nlTrainPackages]

export const trainPackages = [...ukTrainPackages, ...frTrainPackages, ...tnePackages, ...nlTrainPackages]

export const transportPackages = [...flightPackages, ...trainPackages];